import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CreditCard, CalendarCheck, ArrowsClockwise, X } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";

const Subscription = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="subscription-screen">
      {/* Background logo */}
      <div 
        className="absolute inset-0 opacity-[0.03] bg-center bg-no-repeat bg-contain pointer-events-none"
        style={{ backgroundImage: `url(${LOGO_URL})` }}
      />

      <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-xl border-b border-border px-6 py-4">
        <div className="max-w-2xl mx-auto flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="w-10 h-10 rounded-full bg-card flex items-center justify-center" data-testid="back-btn">
            <ArrowLeft weight="bold" className="w-5 h-5 text-foreground" />
          </button>
          <h1 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Subscription & Billing</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-6 py-8 relative z-10">
        <div className="text-center mb-10">
          <div className="w-16 h-16 rounded-2xl bg-[#D4AF37]/10 flex items-center justify-center mx-auto mb-4">
            <CreditCard weight="duotone" className="w-8 h-8 text-[#D4AF37]" />
          </div>
          <h2 className="text-3xl font-bold text-foreground mb-3" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Premium Plans
          </h2>
          <p className="text-muted-foreground">
            Track365 Cardio offers premium features through a subscription.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid gap-4 mb-8">
          {/* Monthly Plan */}
          <div className="premium-card p-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-foreground font-semibold text-lg">Monthly</h3>
                <p className="text-muted-foreground text-sm">Billed monthly</p>
              </div>
              <div className="text-right">
                <p className="text-3xl font-black text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>$9.99</p>
                <p className="text-xs text-muted-foreground">/month</p>
              </div>
            </div>
          </div>

          {/* Yearly Plan - Best Value */}
          <div className="premium-card p-6 border-[#D4AF37]/50 relative">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#D4AF37] text-black text-xs font-bold px-4 py-1 rounded-full">
              BEST VALUE
            </div>
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-[#D4AF37] font-semibold text-lg">Yearly</h3>
                <p className="text-muted-foreground text-sm">Billed annually</p>
                <p className="text-green-500 text-xs mt-1">Save 50%!</p>
              </div>
              <div className="text-right">
                <p className="text-3xl font-black text-[#D4AF37]" style={{ fontFamily: 'Outfit, sans-serif' }}>$59.99</p>
                <p className="text-xs text-muted-foreground">/year</p>
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="space-y-4">
          <div className="premium-card p-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <ArrowsClockwise weight="duotone" className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h4 className="text-foreground font-medium">Auto-Renewal</h4>
                <p className="text-sm text-muted-foreground">Subscriptions renew automatically unless canceled.</p>
              </div>
            </div>
          </div>

          <div className="premium-card p-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-[#D4AF37]/10 flex items-center justify-center flex-shrink-0">
                <CalendarCheck weight="duotone" className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <div>
                <h4 className="text-foreground font-medium">Cancel Anytime</h4>
                <p className="text-sm text-muted-foreground">Manage or cancel through your app store settings.</p>
              </div>
            </div>
          </div>

          <div className="premium-card p-5">
            <div className="flex items-center gap-4">
              <div className="w-10 h-10 rounded-xl bg-red-500/10 flex items-center justify-center flex-shrink-0">
                <X weight="bold" className="w-5 h-5 text-red-500" />
              </div>
              <div>
                <h4 className="text-foreground font-medium">No Refunds</h4>
                <p className="text-sm text-muted-foreground">No refunds are issued for partial billing periods.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center py-8 border-t border-border mt-8">
          <p className="text-muted-foreground text-sm mb-4">
            For billing support, contact
          </p>
          <a href="mailto:support@track365cardio.com" className="text-[#D4AF37] hover:underline">
            support@track365cardio.com
          </a>
        </div>
      </main>
    </div>
  );
};

export default Subscription;
